import { PaymentMethod } from "@source@/common/enums.js";
import "@source@/common/base.js";

"use strict";


$(function() {
  /* Disable button on form submit */
  $('#formularForm').each(function(idx, item) {
    const $button = $('button[type="submit"]', $(this));
    $button.prop("disabled", false);
  }).on('submit', function(event) {
    const $button = $('button[type="submit"]', $(this));
    $button.prop("disabled", true);
  });

  const $list = $('ul.magazines'),
    $activeElem = $('li.active', $list),
    $variantId  = $('input[name="variantId"]');

  /* Preselect*/
  if ($activeElem[0]) {
    /* Select initially active on load */
    $variantId.val($activeElem.data('id'));
    $('button', $activeElem).html('ausgewählt <i class="fa fa-check"></i>');
  }

  /* Manual selection */
  $list.on('click', 'button,img', function(ev) {
    const $next = $(this).parentsUntil('ul', 'li'),
      $button = $('button', $next),
      $prev = $next.siblings('.active');

    $variantId.val($next.data('id'));
    $next.addClass('active');
    $button.html('ausgewählt <i class="fa fa-check"></i>');

    if ($prev[0]) {
      $prev.removeClass('active');
      $('button', $prev).html('auswählen <i class="fa fa-angle-right"></i>');
    }
  });

  function toggleDeliveryAddress(field) {
    const $deliveryAddressGroup = $("#deliveryAddressGroup");
    const hasDeliveryAddress = field.checked || false;

    $deliveryAddressGroup.toggleClass("d-none", !hasDeliveryAddress);
    $(":input", $deliveryAddressGroup).each(function(idx, elem) {
      $(elem).prop("disabled", !hasDeliveryAddress);
    });
  }

  $('input[name="deliveryAddress"]').on("ifChanged", function(event) {
    return toggleDeliveryAddress(this);
  }).each(function() {
    toggleDeliveryAddress(this);
    return false;
  });


  function togglePaymentMethod(field) {
    const $paymentDirectDebit = $("#paymentDirectDebit");
    switch (parseInt($(field).val(), 10)) {
    case PaymentMethod.DIRECT_DEBIT:
      $paymentDirectDebit.toggleClass("d-none", false);
      $('input', $paymentDirectDebit)
        .prop("disabled", false);
      break;
    default:
      $paymentDirectDebit.toggleClass("d-none", true);
      $('input', $paymentDirectDebit)
        .prop("disabled", true);
      break;
    }
  }

  $('input[name="paymentMethod"]').on("ifChecked", function(event) {
    togglePaymentMethod(this);
  }).each(function(idx, elem) {
    if (this.checked) togglePaymentMethod(this);
  });
});



// WEBPACK FOOTER //
// ./assets/scripts/checkout.js